import React, { Component, Fragment, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
	getMenuTotalPrice,
	getProductTotalPrice,
} from "../../../utils/commons";
import services from "../../../api/services";
import { addBasket } from "../../../redux/reducers/basket";
import QuickviewOptions from "../../layouts/QuickviewOptions";
import { Link } from "react-router-dom";

const Content = (props) => {
	const basket = useSelector((state) => state.basket);
	const application = useSelector((state) => state.restaurant.application);
	const dispatch = useDispatch();
	const isAddingToCart = useRef(false);
	const [state, setState] = useState({
		quantity: 1,
		isReady: false,
		menu: null,
	});

	const IncrementItem = () => {
		setState({ ...state, quantity: state.quantity + 1 });
	};

	const DecreaseItem = () => {
		if (state.quantity < 1) {
			setState({ ...state, quantity: 0 });
		} else {
			setState({ ...state, quantity: state.quantity - 1 });
		}
	};

	const handleChange = (event) => {
		setState({ ...state, quantity: event.target.value });
	};

	useEffect(() => {
		if (props.productId) {
			services.getMenuDetails(
				props.productId,
				(res) => {
					let selectedItems = {};
					let selectedProductCategories = {};

					let menu = res.menu;
					let menuPrice = parseFloat(menu.price);
					let quantity = 1;
					// if (timestamp) {
					//   let existingItem = res.results.basketStore.items.find(
					//     (elt) => elt.timestamp == timestamp,
					//   );
					//   selectedItems = existingstate.menu.content;
					//   quantity = existingstate.menu.quantity;
					//   menuPrice = parseFloat(existingstate.menu.price);
					// }

					for (let i = 0; i < menu.menuParts.length; i++) {
						let menuPart = menu.menuParts[i];
						if (
							menuPart.mandatory &&
							menuPart.products.length === menuPart.itemsAllowed &&
							menuPart.products.filter((prod) => prod.disabled).length < 1
						) {
							let arr = [];
							for (let prod of menuPart.products) {
								arr.push(prod);
								//selectedProductCategories.push(prod.categoryName);
							}
							selectedItems[menuPart.menuPartId] = arr;
						}
					}

					setState({
						...state,
						menu,
						isReady: true,
						selectedItems,
						selectedProductCategories,
						totalPrice: menuPrice.toFixed(2),
						quantity,
					});
				},
				(error) => {}
			);
		}
	}, []);

	const onSelected = (menuPart, product) => {
		// add item and price to totalPrice on first press, deletes from and substract from totalPrice on 2nd
		let selectedItems = {
			...state.selectedItems,
		};
		let max =
			menuPart.itemsAllowed && !menuPart.supplementAfterMaxAllowed
				? menuPart.itemsAllowed
				: 0;

		let array = selectedItems[menuPart.menuPartId] || [];
		let newPrice = parseFloat(state.totalPrice);
		product.newPrice = parseFloat(product.price);
		let goNext = false;

		let uniqueProduct = menuPart.products.find((elt) => elt.uniqueInPart);
		let hasUniqueSelected =
			uniqueProduct && array.indexOf(uniqueProduct.menuPartItemId) !== -1;

		const foundIndex = array.findIndex(
			(elt) => elt.menuPartItemId == product.menuPartItemId
		);
		// const foundIndex = array.indexOf(product.menuPartItemId);

		let nbItemsInPart = getNbItemsInPart(array);

		let productPrice = parseFloat(product.price);
		product.quantity = 1;

		if (foundIndex > -1) {
			// if (array[foundIndex].supplement) {
			// 	newPrice -= productPrice;
			// }
			array.splice(foundIndex, 1);
		} else if (product.uniqueInPart) {
			array = [
				{
					...product,
					order: menuPart.menuPartOrder,
					supplementAfterMaxAllowed: menuPart.supplementAfterMaxAllowed,
					itemsAllowed: menuPart.itemsAllowed,
				},
			];
			goNext = true;
		} else if (max && nbItemsInPart == max) {
			array[0] = {
				...product,
				order: menuPart.menuPartOrder,
				supplementAfterMaxAllowed: menuPart.supplementAfterMaxAllowed,
				itemsAllowed: menuPart.itemsAllowed,
			};
		} else {
			if (hasUniqueSelected) {
				array.splice(array.indexOf(uniqueProduct.menuPartItemId), 1);
			}

			array.push({
				...product,
				order: menuPart.menuPartOrder,
				supplementAfterMaxAllowed: menuPart.supplementAfterMaxAllowed,
				itemsAllowed: menuPart.itemsAllowed,
			});
		}
		selectedItems[menuPart.menuPartId] = [...array];

		let indexMP = state.menu.menuParts.findIndex(
			(elt) => elt.menuPartId == menuPart.menuPartId
		);
		let nextIndexMP = indexMP + 1;
		if (
			array.length == 0 &&
			nextIndexMP < state.menu.menuParts.length &&
			state.menu.menuParts[nextIndexMP].linkPreviousPart &&
			selectedItems[state.menu.menuParts[nextIndexMP].menuPartId]
		) {
			selectedItems[state.menu.menuParts[nextIndexMP].menuPartId] = [];
		}

		nbItemsInPart = getNbItemsInPart(array);
		const totalPrice = getMenuTotalPrice(state.menu.price, selectedItems);

		let showOptions = false;
		let currentProduct = state.currentProduct;

		if (product.optionLists && product.optionLists.length) {
			currentProduct = product;
			showOptions = true;
		}

		setState({
			...state,
			selectedItems,
			totalPrice,
			showOptions,
			currentProduct,
		});
	};

	const onSelectOptions = ({ selectedOptions, content }) => {
		const selectedItems = { ...state.selectedItems };
		const selectedProduct = selectedItems[state.currentProduct.menuPartId].find(
			(p) => p.menuPartItemId == state.currentProduct.menuPartItemId
		);
		selectedProduct.selectedOptions = selectedOptions.sort(
			(a, b) => a.order - b.order
		);
		selectedProduct.content = content;

		const currentProductPrice = getProductTotalPrice(
			state.currentProduct.supplement ? state.currentProduct.price : 0,
			state.currentProduct,
			selectedProduct.content
		);
		selectedProduct.price = currentProductPrice;
		selectedProduct.supplement = currentProductPrice > 0 ? 1 : 0;

		const totalPrice = getMenuTotalPrice(state.menu.price, selectedItems);

		console.log({ totalPrice });

		setState({
			...state,
			selectedItems,
			showOptions: false,
			currentProduct: null,
			optionsContent: null,
			totalPrice,
		});
		document.documentElement.style.overflowY = "scroll";
	};
	const editOptions = (product) => {
		const optionsContent = state.selectedItems[product.menuPartId].find(
			(p) => p.menuPartItemId == product.menuPartItemId
		).content;

		setState({
			...state,
			showOptions: true,
			currentProduct: product,
			optionsContent,
		});
	};

	const checkLinkedPart = (menuPart) => {
		const linkedPartItems = state.menu.menuParts
			.map((mp) =>
				mp.products.filter((p) => p.linkedPart == menuPart.menuPartId)
			)
			.flat();

		const hasItemLinkedPartSelected = linkedPartItems.some(
			(lpi) =>
				state.selectedItems[lpi.menuPartId] &&
				state.selectedItems[lpi.menuPartId].find(
					(p) => p.menuPartItemId == lpi.menuPartItemId
				)
		);

		return hasItemLinkedPartSelected;
	};

	const canAddToBasket = () => {
		// user can only add to cart when he selected at least all the mandatory sections, with the right number of items
		let bool = true;

		state.menu.menuParts.map((menuPart, index) => {
			const prevMP = index > 0 && state.menu.menuParts[index - 1];
			if (
				menuPart.mandatory &&
				(!menuPart.linkPreviousPart ||
					(prevMP &&
						state.selectedItems[prevMP.menuPartId] &&
						state.selectedItems[prevMP.menuPartId].length)) &&
				(!menuPart.isLinked || (menuPart.isLinked && checkLinkedPart(menuPart)))
			) {
				if (
					!state.selectedItems[menuPart.menuPartId] ||
					state.selectedItems[menuPart.menuPartId].length !==
						menuPart.itemsAllowed
				) {
					bool = false;
				}
			}
		});
		return bool;
	};

	const addToCart = (selectedItems) => {
		if (canAddToBasket() && !isAddingToCart.current) {
			isAddingToCart.current = true;
			addItemToCart(selectedItems || state.selectedItems);

			// navigate("/");
		}
	};

	const addItemToCart = (selectedItems) => {
		let item = { ...state.menu };
		delete item.menuParts;
		item.menuPrice = state.menu.price;
		item.quantity = state.quantity;
		item.price = state.totalPrice;
		item.basePrice = item.price;
		item.content = selectedItems;

		item.selectedItems = Object.values(selectedItems)
			.reduce((acc, item) => {
				acc.push(...item);
				return acc;
			}, [])
			.sort((a, b) => a.order - b.order);

		item.timestamp = state.timestamp;
		item.status = "pending";
		item.type = "menu";
		item.id = state.menu.menuId;

		dispatch(addBasket(item));

		window.location.href = "/";

		// props.onHide();
	};

	const isMenuPartDisabled = (menuPart, index) => {
		const lastMP = index > 0 && state.menu.menuParts[index - 1];
		return (
			(menuPart.linkPreviousPart &&
				lastMP &&
				(!state.selectedItems[lastMP.menuPartId] ||
					!state.selectedItems[lastMP.menuPartId].length)) ||
			(menuPart.isLinked && !checkLinkedPart(menuPart))
		);
	};

	const getNbItemsInPart = (menuPartItems) => {
		return menuPartItems
			? menuPartItems.reduce((acc, curr) => (acc += curr.quantity), 0)
			: 0;
	};

	const addQuantity = (menuPart, product) => {
		let max =
			menuPart.itemsAllowed && !menuPart.supplementAfterMaxAllowed
				? menuPart.itemsAllowed
				: 0;
		let selectedItems = state.selectedItems;
		let nbItemsInPart = getNbItemsInPart(selectedItems[menuPart.menuPartId]);

		if (max && nbItemsInPart == max && !menuPart.supplementAfterMaxAllowed) {
			return;
		}

		let foundIndex = selectedItems[menuPart.menuPartId].findIndex(
			(elt) => elt.menuPartItemId == product.menuPartItemId
		);
		selectedItems[menuPart.menuPartId][foundIndex].quantity += 1;

		nbItemsInPart = getNbItemsInPart(selectedItems[menuPart.menuPartId]);

		const totalPrice = getMenuTotalPrice(state.menu.price, selectedItems);

		setState({ ...state, selectedItems, totalPrice });
	};

	const removeQuantity = (menuPart, product) => {
		let selectedItems = state.selectedItems;
		let foundIndex = selectedItems[menuPart.menuPartId].findIndex(
			(elt) => elt.menuPartItemId == product.menuPartItemId
		);
		selectedItems[menuPart.menuPartId][foundIndex].quantity -= 1;

		if (selectedItems[menuPart.menuPartId][foundIndex].quantity == 0) {
			selectedItems[menuPart.menuPartId].splice(foundIndex, 1);
		}

		const totalPrice = getMenuTotalPrice(state.menu.price, selectedItems);

		setState({ ...state, selectedItems, totalPrice });
	};

	const renderMenuPart = (menuPart, i) => {
		const isDisabled = isMenuPartDisabled(menuPart, i);
		const nbItemsInPart = getNbItemsInPart(
			state.selectedItems[menuPart.menuPartId]
		);

		return isDisabled ? null : (
			<>
				<div
					key={i}
					className={
						"col-lg-4 col-md-6  col-12 menu-part" +
						(isDisabled ? " disabled" : "")
					}
				>
					<div className="customize-variation-wrapper">
						{/* <i className={menuPart.icon} /> */}
						<h5
							className={
								"menu-part-title" + (menuPart.mandatory ? " mandatory" : "")
							}
						>
							{menuPart.name}{" "}
							<span className="menu-part-subtitle">
								{menuPart.mandatory
									? "Obligatoire - " + menuPart.itemsAllowed + " au choix"
									: ""}
							</span>
						</h5>
						{menuPart.products
							.filter(
								(product) =>
									!product.servicesAvailability ||
									product.servicesAvailability.includes(basket.mode)
							)
							.map((product, i) => {
								const isSelected =
									state.selectedItems[menuPart.menuPartId] &&
									state.selectedItems[menuPart.menuPartId].find(
										(elt) => elt.menuPartItemId == product.menuPartItemId
									);

								const showPrice =
									product.price &&
									(!isSelected ||
										isSelected.supplementAfterMax ||
										isSelected.supplement);

								return (
									<div key={i} className="customize-variation-item">
										<div
											className={
												"custom-control custom-" +
												(menuPart.mandatory && menuPart.itemsAllowed == 1
													? "radio"
													: "checkbox")
											}
											style={{ display: "flex" }}
										>
											<input
												disabled={isDisabled || product.disabled}
												type={
													menuPart.mandatory && menuPart.itemsAllowed == 1
														? "radio"
														: "checkbox"
												}
												name={"part-" + menuPart.menuPartId}
												id={"product-" + product.menuPartItemId}
												className="custom-control-input"
												checked={
													(state.selectedItems[menuPart.menuPartId] &&
														state.selectedItems[menuPart.menuPartId].find(
															(elt) =>
																elt.menuPartItemId == product.menuPartItemId
														)) ||
													false
												}
												onChange={(event) => {
													onSelected(menuPart, product);
												}}
											/>
											<label
												className="custom-control-label"
												htmlFor={"product-" + product.menuPartItemId}
											>
												{product.name}
											</label>
										</div>
										{isSelected &&
										menuPart.enableQuantity &&
										(menuPart.itemsAllowed > 1 ||
											(menuPart.itemsAllowed == 1 &&
												menuPart.supplementAfterMaxAllowed)) ? (
											<div className="qty">
												<span
													className="qty-subtract"
													onClick={() => removeQuantity(menuPart, product)}
												>
													<i className="fa fa-minus" />
												</span>
												<input
													type="text"
													name="clicks"
													value={
														state.selectedItems[menuPart.menuPartId].find(
															(p) => p.menuPartItemId == product.menuPartItemId
														).quantity
													}
													readOnly
												/>
												<span
													className="qty-add"
													onClick={() => addQuantity(menuPart, product)}
												>
													<i className="fa fa-plus" />
												</span>
											</div>
										) : null}
										{product.disabled ? (
											<span style={{ fontSize: 11, color: "#B22222" }}>
												INDISPONIBLE
											</span>
										) : product.price > 0 &&
										  (product.supplement ||
												(menuPart.supplementAfterMaxAllowed &&
													nbItemsInPart >= menuPart.itemsAllowed)) &&
										  showPrice ? (
											<span>+ {parseFloat(product.price).toFixed(2)} €</span>
										) : null}
										{isSelected && isSelected.selectedOptions && (
											<span
												className="underlined pointer"
												onClick={() => editOptions(product)}
											>
												<i className="fas fa-pen" /> Options
											</span>
										)}
									</div>
								);
							})}
					</div>
				</div>
			</>
		);
	};

	const modalClose = () => {
		document.documentElement.style.overflowY = "scroll";

		const selectedItems = { ...state.selectedItems };
		if (
			!selectedItems[state.currentProduct.menuPartId].find(
				(p) => p.menuPartItemId == state.currentProduct.menuPartItemId
			).selectedOptions
		) {
			const fIndex = selectedItems[state.currentProduct.menuPartId].findIndex(
				(p) => p.menuPartItemId == state.currentProduct.menuPartItemId
			);

			selectedItems[state.currentProduct.menuPartId].splice(fIndex, 1);
		}

		setState({
			...state,
			selectedItems,
			showOptions: false,
			currentProduct: null,
			optionsContent: null,
		});
	};

	return (
		<Fragment>
			{state.isReady ? (
				<div className="section product-single">
					<div className="container">
						{/* <div>
							<Link to={"/"}>
								<i className="fa fa-arrow-left" />{" "}
								<span className="underlined">Retour</span>
							</Link>
						</div> */}
						<div className="row">
							<div className="col-md-5">
								{/* Main Thumb */}
								<div className="product-thumb">
									<img src={state.menu.image} alt={state.menu.name} />
								</div>
								{/* /Main Thumb */}
							</div>
							<div className="title-container col-md-7">
								<div className="customize-meta" style={{ flex: 1 }}>
									<h2 className="customize-title">
										{state.menu.name}{" "}
										<span className="custom-primary">
											{parseFloat(state.menu.price).toFixed(2)} €
										</span>{" "}
									</h2>
									<p>{state.menu.description}</p>
								</div>
							</div>
						</div>

						<div>
							<div className="col-md-12">
								<div className="product-content">
									<div className="customize-variations">
										<div className="row">
											{state.menu.menuParts.map(
												(menuPart, i) => renderMenuPart(menuPart, i)

												// 	(<div key={i} className="col-lg-6 col-12">
												// 		<div className="customize-variation-wrapper">
												// 			{/* <i className="flaticon-bread-roll" /> */}
												// 			<h5>
												// 				{menuPart.name} {menuPart.mandatory ? "*" : ""}
												// 			</h5>
												// 			{menuPart.products.map((product, i) => {
												// 				return (
												// 					<div
												// 						key={i}
												// 						className="customize-variation-item"
												// 					>
												// 						<div
												// 							className={
												// 								"custom-control custom-" +
												// 								(menuPart.mandatory &&
												// 								menuPart.itemsAllowed == 1
												// 									? "radio"
												// 									: "checkbox")
												// 							}
												// 						>
												// 							<input
												// 								type={
												// 									menuPart.mandatory &&
												// 									menuPart.itemsAllowed == 1
												// 										? "radio"
												// 										: "checkbox"
												// 								}
												// 								name={"part-" + menuPart.menuPartId}
												// 								id={"product-" + product.menuPartItemId}
												// 								className="custom-control-input"
												// 								checked={
												// 									(state.selectedItems[
												// 										menuPart.menuPartId
												// 									] &&
												// 										state.selectedItems[
												// 											menuPart.menuPartId
												// 										].find(
												// 											(elt) =>
												// 												elt.menuPartItemId ==
												// 												product.menuPartItemId
												// 										)) ||
												// 									false
												// 								}
												// 								onChange={(event) => {
												// 									onSelected(menuPart, product);
												// 								}}
												// 							/>
												// 							<label
												// 								className="custom-control-label"
												// 								htmlFor={
												// 									"product-" + product.menuPartItemId
												// 								}
												// 							>
												// 								{product.name}
												// 							</label>
												// 						</div>
												// 						{product.supplement ? (
												// 							<span>
												// 								+ {parseFloat(product.price).toFixed(2)}{" "}
												// 								€
												// 							</span>
												// 						) : null}
												// 					</div>
												// 				);
												// 			})}
												// 		</div>
												// 	</div>
												// )
											)}
											{/* Variation End */}
										</div>
									</div>
									{/* /Variations */}
									{/* Add To Cart Form */}
									<div className="customize-controls">
										<div className="row col-12 align-items-center">
											<div className="form-group col-md-6 col-12">
												<label>Quantité</label>
												<div className="qty">
													<span className="qty-subtract" onClick={DecreaseItem}>
														<i className="fa fa-minus" />
													</span>
													<input
														type="text"
														name="quantity"
														value={state.quantity}
														onChange={(e) => handleChange(e)}
													/>
													<span className="qty-add" onClick={IncrementItem}>
														<i className="fa fa-plus" />
													</span>
												</div>
											</div>
											<div className="col-md-6 col-12">
												<button
													type="button"
													name="button"
													className="btn-custom primary btn-block "
													onClick={() => addToCart()}
												>
													{" "}
													Commander {parseFloat(state.totalPrice).toFixed(2)} €
													<i className="flaticon-shopping-bag" />
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{!!state.showOptions && (
						<Modal
							show={state.showOptions}
							id="customizeModal"
							onHide={modalClose}
							aria-labelledby="contained-modal-title-vcenter"
							size="lg"
							centered
							onShow={() =>
								(document.documentElement.style.overflowY = "hidden")
							}
						>
							<QuickviewOptions
								product={state.currentProduct}
								addItemToCart={(item) => onSelectOptions(item)}
								onHide={modalClose}
								inMenu={true}
								content={state.optionsContent}
							/>
						</Modal>
					)}
				</div>
			) : null}
		</Fragment>
	);
};

export default Content;
